import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
@Pipe({
    name: 'orderBy',
    // pure: false
})
export class OrderByPipe implements PipeTransform {

    transform(records: Array<any> = [], args?: any): any {
     
        if(records){
            console.log("OrderByPipe property:"+args.property+", type:"+args.type+", direction:"+args.direction);
            //return _.orderBy(records, (item:any) => item[args.property], args.direction);

            return records.sort(function (a, b) {
    
                if(args.type==='string'){
                  
                
                    if (a[args.property].toString() < b[args.property].toString()) { 
                        return -1 * args.direction;
                    }
                    else if (a[args.property].toString() > b[args.property].toString()) {
                        return 1 * args.direction;
                    } else {
                        return 0;
                    }
                }else {
                    if (a[args.property] < b[args.property]) { 
                        return -1 * args.direction;
                    }
                    else if (a[args.property] > b[args.property]) {
                        return 1 * args.direction;
                    } else {
                        return 0;
                    }
                }
               
                
            });
         
        }else return 0;

    };

}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/orderByPipe.pipe.ts